<template>
  <div>
    <v-container>
      <div>
        <date-filter
          @changeDate="getData"
          :defaultFilter="'today'"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <div class="mt-3">
        <div class="title mb-3">จำนวนและรายชื่อร้านค้าตามสถานะ</div>
        <v-layout row wrap class="mb-0">
          <v-flex xs6>
            <div>
              <multiselect
                v-model="dealertype"
                label="label"
                :allow-empty="false"
                single-select
                :options="optionType"
                @input="getData"
              ></multiselect>
            </div>
          </v-flex>
          <v-flex xs6 class="pt-3">
            <div class="text-xs-right">ทั้งหมด : {{ total }}</div></v-flex
          >
        </v-layout>
        <v-pagination
          class="mt-2"
          :total-visible="15"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
        <v-data-table
          v-bind:pagination.sync="pagination"
          :headers="headers"
          :items="data"
          class="elevation-1"
          hide-actions
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center pa-3">
                {{ props.item.realname }}
              </td>
              <td class="text-xs-center pa-3">
                {{ props.item.phoneno }}
              </td>
              <td class="text-xs-center pa-3">
                {{ props.item.email }}
              </td>
              <td class="text-xs-center pa-3">
                {{ props.item.address }}
              </td>
              <td class="text-xs-center pa-3">
                {{ props.item.uu_areacode }}
              </td>
              <td class="text-xs-center pa-3">
                {{ props.item.contact_name }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    DateFilter,
    Multiselect
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      dealertype: {
        label: 'ร้านค้าที่ส่งใบประเมินราคาให้ลูกค้า',
        value: 'dealersendquotationdashboard'
      },
      optionType: [
        {
          label: 'ร้านค้าที่ส่งใบประเมินราคาให้ลูกค้า',
          value: 'dealersendquotationdashboard'
        },
        {
          label: 'ร้านค้าที่การชำระเงินสำเร็จ',
          value: 'orderscompletepaymentdashboard'
        },
        {
          label: 'ร้านค้าที่จัดส่งสำเร็จ',
          value: 'ordersshippingdashboard'
        }
      ],
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      total: 0,

      headers: [
        { text: 'ชื่อร้านค้า', value: 'realname', align: 'center', width: '1%' },
        { text: 'เบอร์โทรศัพท์', value: 'phoneno', align: 'center', width: '1%' },
        { text: 'อีเมล', value: 'email', align: 'center', width: '1%' },
        { text: 'ที่อยู่', value: 'address', align: 'center', width: '1%' },
        { text: 'รหัสไปรษณีย์', value: 'uu_areacode', align: 'center', width: '1%' },
        { text: 'ชื่อผู้ติดต่อ', value: 'contact_name', align: 'center', width: '1%' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    onChangeType() {},
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
          limit: this.limit,
          offset: this.offset
        }
        this.loading = true
        api[this.dealertype.value](data, (err, response) => {
          this.loading = false
          this.data = response.data.map((el) => {
            try {
              var contact_name = JSON.parse(el.json_variable).contact_name
            } catch (error) {
              var contact_name = ''
            }

            return { ...el, contact_name }
          })
          if (response.total) {
            this.total = response.total
          } else {
            this.total = 0
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Dealer/dealersendquotation.vue